import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllInstagramMentionedPosts.graphql';
import { Query, QueryallInstagramMentionedPostsArgs } from '../../__generated__/globalTypes';

export const useAllInstagramMentionedPostsQuery = (
  options?: QueryHookOptions<Query, QueryallInstagramMentionedPostsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallInstagramMentionedPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllInstagramMentionedPostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallInstagramMentionedPostsArgs>
): QueryResult<Query, QueryallInstagramMentionedPostsArgs> & {
  getAllInstagramMentionedPosts: LazyQueryExecFunction<Query, QueryallInstagramMentionedPostsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllInstagramMentionedPosts, result] = useLazyQuery<Query, QueryallInstagramMentionedPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllInstagramMentionedPosts, ...result };
};

export const useAllInstagramMentionedPostsPromiseQuery = () => {
  const client = useApolloClient();

  const getAllInstagramMentionedPosts = useCallback(
    (options?: Omit<QueryOptions<QueryallInstagramMentionedPostsArgs, Query>, 'query'>) =>
      client.query<Query, QueryallInstagramMentionedPostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllInstagramMentionedPosts };
};
// Suspense Query Hooks
export const useAllInstagramMentionedPostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallInstagramMentionedPostsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallInstagramMentionedPostsArgs>(QUERY, {
    ...options
  });

  return result;
};
